"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require("./PagingModel");

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CsvModel = function (_PagingModel) {
    _inherits(CsvModel, _PagingModel);

    function CsvModel(observers, id, request) {
        _classCallCheck(this, CsvModel);

        var _this = _possibleConstructorReturn(this, (CsvModel.__proto__ || Object.getPrototypeOf(CsvModel)).call(this, observers, id, request));

        _this.CsvData = {};
        return _this;
    }

    _createClass(CsvModel, [{
        key: "GetCsvData",
        value: function GetCsvData(controller, senddata, start, limit, orderColumn, orderDirection) {
            var me = this;
            var reqString = "/" + controller + this.setSendData(senddata, start, limit, orderColumn, orderDirection);
            this.request.setRequest(reqString);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            var contracts = [];

                            result.Data.Data.forEach(function (value) {
                                var contract = {};
                                contract = value;
                                if (value.DateTo == "0001-01-01T00:00:00") {
                                    contract.DateTo = "";
                                }
                                contracts.push(contract);
                            });

                            me.CsvData = contracts;
                        }
                    }
                }
                var id = me.Id ? me.Id : "CsvData";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }]);

    return CsvModel;
}(_PagingModel3.default);

exports.default = CsvModel;